import { ATTRIB } from 'constants/test';
import { t } from 'services/i18n.service';

interface Props {
  title?: string;
  className?: string;
  minHeight?: string;
  dims?: string;
}

const Spinner = ({
  title,
  className = 'rounded-full border-t-4 border-r border-l-4 border-b border-primary-500 animate-spin',
  minHeight = 'h-[50vh]',
  dims = '~w-6/9 ~h-6/9 '
}: Props) => {
  return (
    <div
      className={`w-full ${
        minHeight ?? 'h-[65vh]'
      } flex items-center justify-center ~gap-2/3`}
    >
      <div
        className={`${dims} ${className}`}
        data-testid={ATTRIB.DATA_TESTID.SPINNER_LOADER}
      ></div>
      <h1 className='~text-lg/4xl text-orange-400 font-semibold'>
        {t(title ?? '')}
      </h1>
    </div>
  );
};

export default Spinner;
